<template>
	<v-dialog
		v-model="dialog"
		width="500"
		persistent
	>
		<v-card>
			<v-card-title
				class="headline light-blue darken-1 white--text"
				primary-title
			>
				{{ $t('personal_finance.dialog_caption_' + tab) }}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout column>
						<v-text-field type="number"
							v-model="amount"
							class="inputPrice"
							:label="$t('personal_finance.amount')"
						/>
						<v-select
							v-if="transferPay"
							v-model="transferUserId"
							:items="$store.state.users.users"
							:label="$t('user.users')"
							item-text="name"
							item-value="id"
						/>
						
						<v-select
							v-if="!transferPay"
							:items="['', ...$store.state.auth.paymentCategories]"
							:label="$t('personal_finance.category')"
							v-model="category"
						/>

						<v-text-field
							v-model="comment"
							:label="$t('personal_finance.comment')"
						/>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="red light-1"
					flat
					@click="dialog = false"
				>
					{{$t('common.cancel')}}
				</v-btn>
				<v-btn v-if="editable"
					color="blue light-1"
					flat
					@click.prevent="editPay"
					:disabled="disabledButton"
				>
					{{$t('common.edit')}}
				</v-btn>
				<v-btn v-else
					color="green light-1"
					flat
					@click.prevent="createPay"
					:disabled="disabledButton"
				>
					{{$t('common.add')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { notify } from '../../utils/notifications'

export default {
	props: [
		'value',
		'editablePay',
		'transferPay',
	],
	data: (vm) => ({
		editable: false,
		amount: null,
		comment: null,
		category: null,
		transferUserId: null,
		disabledButton: false
	}),
	computed: {
		dialog: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		},
		tab() {
			return this.$route.hash.split('#')[1]
		},
		formData() {
			return {
				type: this.tab,
				amount: this.amount,
				comment: this.comment ? this.comment : '',
				category: this.category,
			}
		}
	},
	methods: {
		...mapActions({
			addPay: 'finance/addPay',
			addTransferPay: 'finance/addTransferPay',
			storePay: 'finance/storePay',
			storeTransferPay: 'finance/storeTransferPay'
		}),
		createPay() {
			if(this.disabledButton) return
			this.disabledButton = true
			if(this.transferPay) {
				let query = this.formData
				query.transfer_user_id = this.transferUserId
				query.type = null
				this.addTransferPay(query)
					.then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.created', {type: this.$t('personal_finance.transfer')})
						})
						this.dialog = false
						this.clearFormData()
						this.disabledButton = false
					})
			} else {
				this.addPay(this.formData)
					.then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.created', {type: this.$t('personal_finance.finance')})
						})
						this.dialog = false
						this.clearFormData()
						this.disabledButton = false
					})
			}
		},
		editPay() {
			if(this.disabledButton) return
			this.disabledButton = true
			if(this.editablePay.transaction) {
				let query = this.formData
				query.type = null
				this.storeTransferPay({
					id: this.editablePay.transaction_id,
					data: query
				}).then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.saved', {type: this.$t('personal_finance.transfer')})
						})
						this.dialog = false
						this.clearFormData()
						this.disabledButton = false
					})
			} else {
				this.storePay({
					id: this.editablePay.id,
					data: this.formData
				}).then(() => {
						this.$notify({
							...notify,
							text: this.$t('notifications.saved', {type: this.$t('personal_finance.finance')})
						})
						this.dialog = false
						this.clearFormData()
						this.disabledButton = false
					})
			}
		},
		clearFormData() {
			this.amount = null
			this.comment = null
		}
	},
	watch: {
		editablePay() {
			if(this.editablePay) {
				this.amount = this.editablePay.amount
				this.comment = this.editablePay.comment
				this.category = this.editablePay.category
				this.editable = true
			} else {
				this.amount = null
				this.comment = null
				this.editable = false
			}
		}
	}
}
</script>

<style>

</style>
